/** True when `fileName` ends with any of the supplied extensions (case-insensitive). */
export const hasExtension = (fileName: string, extensions: string[]): boolean => {
  const normalized = fileName?.toLowerCase?.() || ''
  return extensions.some((extension) => normalized.endsWith(extension))
}

export const isImageFile = (fileName: string): boolean =>
  hasExtension(fileName, ['.jpg', '.jpeg', '.png', '.gif', '.webp', '.svg'])

export const isVideoFile = (fileName: string): boolean =>
  hasExtension(fileName, ['.mp4', '.mov', '.avi', '.mkv', '.webm'])

export const isPdfFile = (fileName: string): boolean => hasExtension(fileName, ['.pdf'])

/**
 * Triggers a browser file download for an in-memory blob.
 *
 * Creates a temporary object URL, programmatically clicks an anchor, then
 * revokes the URL. Used by mutations that receive a generated artefact
 * (e.g. a transaction statement export) and need to hand it to the user as
 * a saved file without persisting anything server-side.
 */
export function downloadBlob(blob: Blob, fileName: string): void {
  const objectUrl = URL.createObjectURL(blob)
  const anchor = document.createElement('a')
  anchor.href = objectUrl
  anchor.download = fileName
  anchor.click()
  URL.revokeObjectURL(objectUrl)
}
